import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataService,
    HttpUrlGenerator,
    DefaultDataServiceConfig
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { BudgetLevel } from './budget-level.model';
import * as fromShared from '../../shared';
import { EfaactDataService } from '../efaact.data-service';
export const entityName = 'BudgetLevel';

@Injectable()
export class BudgetLevelDataService extends EfaactDataService<BudgetLevel> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: BudgetLevel): BudgetLevel {
        return {
            ...item,
            id: item.Budgetlevelid
        };
    }
}
